interface CounterCellProps {
  label: string;
  value: number;
  onChange: (v: number) => void;
  warn?: boolean;
}

export function CounterCell({ label, value, onChange, warn }: CounterCellProps) {
  return (
    <div className="flex flex-col items-center gap-1 bg-gray-50 border border-gray-200 rounded-xl p-3">
      <span className="text-[11px] text-gray-500 text-center leading-tight">{label}</span>
      <div className="flex items-center gap-3">
        <button
          type="button"
          className="w-9 h-9 rounded-lg border border-gray-300 bg-white text-gray-700 text-lg font-medium flex items-center justify-center active:scale-95"
          onClick={() => onChange(Math.max(0, value - 1))}
        >−</button>
        <span className={`text-xl font-semibold w-6 text-center ${warn ? "text-red-500" : "text-gray-900"}`}>
          {value}
        </span>
        <button
          type="button"
          className="w-9 h-9 rounded-lg border border-gray-300 bg-white text-gray-700 text-lg font-medium flex items-center justify-center active:scale-95"
          onClick={() => onChange(value + 1)}
        >+</button>
      </div>
    </div>
  );
}
